import { render, staticRenderFns } from "./AdminAcademicCategoriesNew.html?vue&type=template&id=0d2da798&scoped=true&"
import script from "./AdminAcademicCategoriesNew.vue?vue&type=script&lang=js&"
export * from "./AdminAcademicCategoriesNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcademicCategoriesNew.scss?vue&type=style&index=0&id=0d2da798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2da798",
  null
  
)

export default component.exports